<template>
  <div class="diy-banner">
    <van-swipe
      :autoplay="parseInt(params.interval)"
      :class="'banner-box swiper-box dot-'+itemStyle.btnShape"
      :circular="true"
      :indicator-color="itemStyle.btnColor"
      indicator-active-color="#000"
      :data-item-key="itemIndex"
      @change="onChange"
    >
      <van-swipe-item v-for="(banner,index) in datalist" :key="index">
        <div class="slideDiv">
        <img
          @click="navigationTo(banner.linkUrl)"
          :data-url="banner.linkUrl"
          class="slide-image"
          :src="banner.imgUrl"
          :data-id="index"
          :data-item-key="itemIndex"
        >
        </div>
      </van-swipe-item>
      <div class="van-swipe__indicators" slot="indicator">
        <i 
        class="van-swipe__indicator" 
        :style="'background-color:'+itemStyle.btnColor" 
        :class="current==index?'van-swipe__indicator--active '+itemStyle.btnShape:itemStyle.btnShape" 
        v-for="(item,index) in datalist" 
        :key="index"/>
      </div>
    </van-swipe>
  </div>
</template>

<script>
import { Swipe, SwipeItem } from "vant";
import Vue from "vue";
Vue.use(Swipe).use(SwipeItem);
export default {
  props: ["itemIndex", "itemStyle", "params", "datalist"],
  data() {
    return {
      current:0
    }
  },
  created() {},
  activated() {

  },
  methods:{
   navigationTo(url){
     if(url.indexOf('pavilion')==-1){
       this.$router.push(url)
     }else{
       window.location.href='https://m.p.gemtec.ltd/#/pavilion-view/5cda8b08422689685307b815?Source=zs'
     }
   },
   onChange(index){
     this.current = index;
   }
  }
};
</script>

<style lang="less" scoped>
@import url("../../style/skin.less");
/* banner轮播 */

.diy-banner {
  position: relative;
}

.slideDiv{
  width: 100%;
  height: calc(100vh - 50px);
}

.diy-banner .slide-image {
  width: 100%;
  height:  calc(100vh - 50px);
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  margin: 0 auto;
  display: block;
}

/* 顶部置灰 */

.diy-banner .linear {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3.4rem;
  background: linear-gradient(#111, transparent);
  opacity: 0.6;
  z-index: 9;
}

.swiper-box .wx-swiper-dots.wx-swiper-dots-horizontal {
  margin-bottom: 1px;
}

/* banner组件按钮 */

.swiper-box .wx-swiper-dot {
  height: 10px;
  width: 10px;
}

.swiper-box.dot-rectangle .wx-swiper-dot {
  width: 15px;
  border-radius: unset;
}

.swiper-box.dot-square .wx-swiper-dot {
  border-radius: unset;
}

.square{
  width:10px;
  height:10px;
  border-radius: 0px !important;
}

.rectangle{
  width:16px;
  height:10px;
  border-radius: 0px !important;
}
@media (device-height: 812px) and (device-width: 375px) {
  .diy-banner .slide-image {
    height:  calc(100vh - 80px);
  }
}
</style>